/* Sugar Rush theme JS — 2026 edition.
   Drawer, quantity steppers, variant pricing, gallery, scroll-reveal,
   glassy header, card tilt, and an AJAX add-to-cart with confetti + toast.
   All enhancements are progressive: if JS fails, native forms still work. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Focus trap helper ----------------------------------------------------- */
  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var trapState = null;

  function trapFocus(panel) {
    releaseFocus();
    trapState = { panel: panel, returnTo: document.activeElement, handler: null };
    var first = panel.querySelector(FOCUSABLE);
    if (first) first.focus();
    trapState.handler = function (e) {
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var firstEl = items[0];
      var lastEl = items[items.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
    };
    document.addEventListener('keydown', trapState.handler);
  }

  function releaseFocus() {
    if (!trapState) return;
    document.removeEventListener('keydown', trapState.handler);
    if (trapState.returnTo && trapState.returnTo.focus) trapState.returnTo.focus();
    trapState = null;
  }

  /* Mobile drawer ------------------------------------------------------- */
  var drawer = document.getElementById('MobileDrawer');
  var openBtn = document.getElementById('MenuToggle');

  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) trapFocus(drawer.querySelector('.mobile-drawer__panel'));
    else releaseFocus();
  }

  if (openBtn && drawer) {
    openBtn.addEventListener('click', function () { setDrawer(true); });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () { setDrawer(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
    });
  }

  /* Glassy header on scroll --------------------------------------------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Floating bear mascot (scroll-to-top) -------------------------------- */
  var mascot = document.getElementById('Mascot');
  if (mascot) {
    var toggleMascot = function () {
      mascot.classList.toggle('is-shown', window.scrollY > 600);
    };
    toggleMascot();
    window.addEventListener('scroll', toggleMascot, { passive: true });
    mascot.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  /* Scroll-reveal ------------------------------------------------------- */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var revealSelector = '.section-header, .product-card, .collection-card, .testimonial-card, .highlight, .article-card, .image-with-text__media, .image-with-text__content';
    var targets = document.querySelectorAll(revealSelector);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          var el = entry.target;
          el.style.transitionDelay = Math.min(i * 60, 240) + 'ms';
          el.classList.add('is-visible');
          io.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    targets.forEach(function (el) {
      el.classList.add('reveal');
      io.observe(el);
    });
  }

  /* Subtle card tilt ---------------------------------------------------- */
  if (finePointer && !reduceMotion) {
    document.querySelectorAll('.product-card, .collection-card').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var rx = ((e.clientY - r.top) / r.height - 0.5) * -6;
        var ry = ((e.clientX - r.left) / r.width - 0.5) * 6;
        card.style.transform = 'translateY(-0.5rem) perspective(700px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg)';
      });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });
  }

  /* Slideshow ------------------------------------------------------------ */
  document.querySelectorAll('[data-slideshow]').forEach(function (slider) {
    var slides = slider.querySelectorAll('.slideshow__slide');
    if (slides.length < 2) return;
    var dots = slider.querySelectorAll('[data-slide-dot]');
    var current = 0;
    var timer = null;
    var autoplay = slider.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var speed = parseInt(slider.getAttribute('data-speed'), 10) || 6000;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
    }

    function restart() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(function () { show(current + 1); }, speed);
    }

    var prev = slider.querySelector('[data-slide-prev]');
    var next = slider.querySelector('[data-slide-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); restart(); });
    if (next) next.addEventListener('click', function () { show(current + 1); restart(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-slide-dot'), 10)); restart(); });
    });
    slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    slider.addEventListener('mouseleave', restart);

    var touchX = null;
    slider.addEventListener('touchstart', function (e) { touchX = e.changedTouches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) < 40) return;
      show(dx < 0 ? current + 1 : current - 1);
      restart();
    }, { passive: true });

    restart();
  });

  /* Rotating banners ------------------------------------------------------ */
  document.querySelectorAll('[data-rotator]').forEach(function (rotator) {
    var items = rotator.querySelectorAll('[data-rotator-item]');
    if (items.length < 2) return;
    var dots = rotator.querySelectorAll('[data-rotator-dot]');
    var current = 0;
    var speed = parseInt(rotator.getAttribute('data-speed'), 10) || 5000;
    var timer = null;

    function show(i) {
      current = (i + items.length) % items.length;
      items.forEach(function (el, idx) { el.classList.toggle('is-active', idx === current); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
    }

    function start() {
      if (reduceMotion) return;
      clearInterval(timer);
      timer = setInterval(function () { show(current + 1); }, speed);
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-rotator-dot'), 10)); start(); });
    });
    rotator.addEventListener('mouseenter', function () { clearInterval(timer); });
    rotator.addEventListener('mouseleave', start);
    start();
  });

  /* Clamped intro text (Read more / Read less) ----------------------------- */
  document.querySelectorAll('[data-clamp]').forEach(function (wrap) {
    var text = wrap.querySelector('.collection-intro__text');
    var toggle = wrap.querySelector('[data-clamp-toggle]');
    if (!text || !toggle) return;
    // Only show the toggle when the text actually overflows its clamp
    if (text.scrollHeight > text.clientHeight + 2) {
      toggle.hidden = false;
      toggle.addEventListener('click', function () {
        var expanded = wrap.classList.toggle('is-expanded');
        toggle.textContent = expanded ? 'Read less' : 'Read more';
      });
    }
  });

  /* Quantity steppers --------------------------------------------------- */
  document.querySelectorAll('[data-quantity]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    if (!input) return;
    wrap.querySelectorAll('button[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
        var min = parseInt(input.min, 10) || 0;
        var next = (parseInt(input.value, 10) || 0) + step;
        input.value = Math.max(min, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Variant select: update price + availability ------------------------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var select = form.querySelector('select[name="id"]');
    var priceEl = form.querySelector('[data-price]');
    var button = form.querySelector('[data-add-button]');
    if (!select) return;

    function update() {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      if (priceEl && opt.dataset.price) priceEl.innerHTML = opt.dataset.price;
      if (button) {
        var available = opt.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available
          ? button.getAttribute('data-label-add')
          : button.getAttribute('data-label-sold-out');
      }
    }
    select.addEventListener('change', update);
    update();
  });

  /* Product gallery thumbnails ------------------------------------------ */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-main-image]');
    if (!main) return;
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-full');
        main.srcset = '';
      });
    });
  });

  /* Cart page: auto-submit on quantity change --------------------------- */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.querySelectorAll('[data-quantity] input').forEach(function (input) {
      input.addEventListener('change', function () { cartForm.submit(); });
    });
  }

  /* ------------------------------------------------------------------ */
  /* AJAX add-to-cart: confetti + toast, no full page reload            */
  /* ------------------------------------------------------------------ */
  function showToast(title, sub) {
    var existing = document.querySelector('.toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      '<span class="toast__emoji" aria-hidden="true">🎉</span>' +
      '<span class="toast__text">' + title + (sub ? '<small>' + sub + '</small>' : '') + '</span>' +
      '<a class="toast__cta" href="/cart">View cart</a>';
    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 400);
    }, 4200);
  }

  function bumpCartCount(count) {
    var bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) {
      var cartLink = document.querySelector('.site-header__icons a[href*="cart"]');
      if (cartLink) {
        bubble = document.createElement('span');
        bubble.className = 'cart-count-bubble';
        bubble.setAttribute('aria-hidden', 'true');
        cartLink.appendChild(bubble);
      }
    }
    if (bubble) {
      bubble.textContent = count;
      bubble.classList.remove('is-bumped');
      void bubble.offsetWidth;
      bubble.classList.add('is-bumped');
    }
  }

  function confettiBurst(originX, originY) {
    if (reduceMotion) return;
    var colors = ['#ED257B', '#046E82', '#FFAB41', '#ffffff', '#7ad7c5'];
    var canvas = document.createElement('canvas');
    canvas.className = 'confetti-canvas';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var dpr = window.devicePixelRatio || 1;
    function size() { canvas.width = innerWidth * dpr; canvas.height = innerHeight * dpr; }
    size();
    var pieces = [];
    for (var i = 0; i < 90; i++) {
      var angle = Math.random() * Math.PI * 2;
      var speed = 6 + Math.random() * 9;
      pieces.push({
        x: originX * dpr, y: originY * dpr,
        vx: Math.cos(angle) * speed * dpr,
        vy: (Math.sin(angle) * speed - 6) * dpr,
        size: (5 + Math.random() * 7) * dpr,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.4,
        color: colors[(Math.random() * colors.length) | 0],
        life: 0
      });
    }
    var gravity = 0.32 * dpr;
    var start = performance.now();
    function frame(now) {
      var t = now - start;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      pieces.forEach(function (p) {
        p.vy += gravity;
        p.x += p.vx;
        p.y += p.vy;
        p.vx *= 0.99;
        p.rot += p.vr;
        p.life = t;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.globalAlpha = Math.max(0, 1 - t / 1400);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        ctx.restore();
      });
      if (t < 1500) {
        requestAnimationFrame(frame);
      } else {
        canvas.remove();
      }
    }
    requestAnimationFrame(frame);
  }

  /* Money formatting (uses the shop's money format) ----------------------- */
  function formatMoney(cents) {
    var fmt = (window.SugarRush && window.SugarRush.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, '');
  }

  /* Cart drawer ----------------------------------------------------------- */
  var Drawer = (function () {
    var el = document.getElementById('CartDrawer');
    if (!el) return null;
    var itemsEl = el.querySelector('[data-cart-drawer-items]');
    var emptyEl = el.querySelector('[data-cart-drawer-empty]');
    var footerEl = el.querySelector('[data-cart-drawer-footer]');
    var countEl = el.querySelector('[data-cart-drawer-count]');
    var subtotalEl = el.querySelector('[data-cart-drawer-subtotal]');
    var meter = el.querySelector('[data-shipping-meter]');

    function open() {
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      trapFocus(el.querySelector('.cart-drawer__panel'));
    }

    function close() {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      releaseFocus();
    }

    var lastTotal = null;

    function updateMeter(totalCents) {
      document.querySelectorAll('[data-shipping-meter]').forEach(function (m) {
        var threshold = parseInt(m.getAttribute('data-threshold'), 10) || 0;
        if (!threshold) return;
        var label = m.querySelector('[data-shipping-meter-label]');
        var fill = m.querySelector('[data-shipping-meter-fill]');
        var pct = Math.min(100, (totalCents / threshold) * 100);
        if (fill) {
          fill.style.width = pct + '%';
          fill.classList.toggle('is-unlocked', totalCents >= threshold);
        }
        if (label) {
          label.innerHTML = totalCents >= threshold
            ? '🎉 You unlocked <span class="sweet">FREE shipping!</span>'
            : 'You are <span class="sweet">' + formatMoney(threshold - totalCents) + '</span> away from FREE shipping 🚚';
        }
        // Celebrate the moment free shipping is unlocked
        if (lastTotal !== null && lastTotal < threshold && totalCents >= threshold) {
          confettiBurst(innerWidth / 2, innerHeight / 3);
        }
      });
      lastTotal = totalCents;
    }

    var cheers = ['Sweet choice! 🍬', 'Ooh, good pick! 🍭', 'Excellent taste ✨', 'That one is a fan favorite 🐻', 'Adding joy to cart… done! 🎉'];

    function showCheer() {
      var cheer = el.querySelector('[data-drawer-cheer]');
      if (!cheer) return;
      cheer.textContent = cheers[(Math.random() * cheers.length) | 0];
      cheer.hidden = false;
      cheer.classList.remove('is-fresh');
      void cheer.offsetWidth;
      cheer.classList.add('is-fresh');
    }

    function render(cart) {
      if (countEl) countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if (emptyEl) emptyEl.hidden = cart.item_count > 0;
      if (footerEl) footerEl.hidden = cart.item_count === 0;
      updateMeter(cart.total_price);
      bumpCartCount(cart.item_count);
      if (!itemsEl) return;
      itemsEl.innerHTML = cart.items.map(function (item, i) {
        var img = item.image
          ? '<img class="drawer-item__image" src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '$1') + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=140" alt="" width="70" height="70">'
          : '<div class="drawer-item__image drawer-item__image--empty"></div>';
        var variant = item.variant_title && item.variant_title.indexOf('Default') === -1
          ? '<span class="drawer-item__variant">' + item.variant_title + '</span>' : '';
        return '<div class="drawer-item" data-line="' + (i + 1) + '">' + img +
          '<div class="drawer-item__info">' +
          '<a class="drawer-item__title" href="' + item.url + '">' + item.product_title + '</a>' + variant +
          '<div class="drawer-item__row">' +
          '<div class="product-form__quantity product-form__quantity--small">' +
          '<button type="button" data-drawer-qty="-1" aria-label="Decrease">−</button>' +
          '<input type="number" value="' + item.quantity + '" min="0" aria-label="Quantity" data-drawer-qty-input>' +
          '<button type="button" data-drawer-qty="1" aria-label="Increase">+</button></div>' +
          '<span class="drawer-item__price">' + formatMoney(item.final_line_price) + '</span>' +
          '</div></div>' +
          '<button class="drawer-item__remove" type="button" data-drawer-remove aria-label="Remove">✕</button></div>';
      }).join('');
    }

    function refresh() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); return cart; });
    }

    function changeLine(line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(render);
    }

    el.querySelectorAll('[data-cart-drawer-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    if (itemsEl) {
      itemsEl.addEventListener('click', function (e) {
        var row = e.target.closest('.drawer-item');
        if (!row) return;
        var line = parseInt(row.getAttribute('data-line'), 10);
        if (e.target.closest('[data-drawer-remove]')) { changeLine(line, 0); return; }
        var stepBtn = e.target.closest('[data-drawer-qty]');
        if (stepBtn) {
          var input = row.querySelector('[data-drawer-qty-input]');
          var next = (parseInt(input.value, 10) || 0) + parseInt(stepBtn.getAttribute('data-drawer-qty'), 10);
          changeLine(line, Math.max(0, next));
        }
      });
      itemsEl.addEventListener('change', function (e) {
        var input = e.target.closest('[data-drawer-qty-input]');
        var row = e.target.closest('.drawer-item');
        if (input && row) changeLine(parseInt(row.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
      });
    }

    var note = el.querySelector('[data-cart-note]');
    if (note) {
      note.addEventListener('change', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      });
    }

    // Cart icon opens the drawer instead of navigating (when enabled)
    if (window.SugarRush && window.SugarRush.cartDrawer) {
      document.querySelectorAll('.site-header__icons a[href*="/cart"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          refresh().then(open);
        });
      });
    }

    refresh();
    return { open: open, close: close, refresh: refresh, cheer: showCheer };
  })();

  function addToCart(body, sourceEl, onDone) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: body
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (item) {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            bumpCartCount(cart.item_count);
            var rect = sourceEl ? sourceEl.getBoundingClientRect() : { left: innerWidth / 2, top: innerHeight / 2, width: 0, height: 0 };
            confettiBurst(rect.left + rect.width / 2, rect.top + rect.height / 2);
            if (Drawer && window.SugarRush && window.SugarRush.cartDrawer) {
              Drawer.refresh().then(function () { Drawer.open(); Drawer.cheer(); });
            } else {
              showToast('Added to cart!', item.product_title || '');
            }
          });
      })
      .then(function () { if (onDone) onDone(true); })
      .catch(function () { if (onDone) onDone(false); });
  }

  /* Quick add from product cards */
  if (window.fetch) {
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var fd = new FormData();
        fd.append('id', btn.getAttribute('data-quick-add'));
        fd.append('quantity', '1');
        var original = btn.textContent;
        btn.textContent = 'Adding…';
        btn.disabled = true;
        addToCart(fd, btn, function () {
          btn.textContent = original;
          btn.disabled = false;
        });
      });
    });
  }

  if (window.fetch) {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var button = form.querySelector('[data-add-button]');
        if (button && button.disabled) return;

        var formData = new FormData(form);
        if (button) {
          button.dataset.original = button.textContent;
          button.textContent = 'Adding…';
          button.disabled = true;
        }

        addToCart(formData, button, function (ok) {
          if (button) {
            button.textContent = button.dataset.original || 'Add to cart';
            button.disabled = false;
          }
          // Fall back to a normal navigation if AJAX fails
          if (!ok) form.submit();
        });
      });
    });
  }

  /* Predictive search ------------------------------------------------------ */
  document.querySelectorAll('.header-search').forEach(function (form) {
    var input = form.querySelector('input[type="search"]');
    if (!input) return;
    var box = document.createElement('div');
    box.className = 'search-suggest';
    form.appendChild(box);
    var timer = null;

    function closeBox() { box.classList.remove('is-open'); }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { closeBox(); return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (((data || {}).resources || {}).results || {}).products || [];
            if (!products.length) { closeBox(); return; }
            var rx = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
            box.innerHTML =
              '<div class="ss-header">🍭 Sweet matches</div>' +
              products.map(function (pr) {
                var img = pr.featured_image && pr.featured_image.url
                  ? '<img src="' + pr.featured_image.url + '" alt="" width="56" height="56">'
                  : '<span class="ss-noimg">🍬</span>';
                var title = pr.title.replace(rx, '<mark>$1</mark>');
                var kicker = pr.type ? '<span class="ss-kicker">' + pr.type + '</span>' : '';
                var priceCents = Math.round(parseFloat(pr.price) * 100);
                var price = isNaN(priceCents) ? '' : '<span class="ss-price">' + formatMoney(priceCents) + '</span>';
                return '<a href="' + pr.url + '"><span class="ss-img">' + img + '</span>' +
                  '<span class="ss-info">' + kicker + '<span class="ss-title">' + title + '</span></span>' +
                  price + '</a>';
              }).join('') +
              '<a class="ss-all" href="/search?q=' + encodeURIComponent(q) + '">See all results →</a>';
            box.classList.add('is-open');
          })
          .catch(closeBox);
      }, 250);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeBox(); return; }
      if (!box.classList.contains('is-open')) return;
      var links = box.querySelectorAll('a');
      if (!links.length) return;
      var focused = box.querySelector('a.is-focused');
      var idx = Array.prototype.indexOf.call(links, focused);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        idx = e.key === 'ArrowDown' ? (idx + 1) % links.length : (idx - 1 + links.length) % links.length;
        links.forEach(function (a) { a.classList.remove('is-focused'); });
        links[idx].classList.add('is-focused');
      } else if (e.key === 'Enter' && focused) {
        e.preventDefault();
        focused.click();
      }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) closeBox(); });
  });

  /* Faceted filtering ------------------------------------------------------- */
  document.querySelectorAll('[data-facets]').forEach(function (form) {
    var debounce = null;
    form.addEventListener('change', function (e) {
      // debounce price inputs; submit checkboxes/sort immediately
      clearTimeout(debounce);
      var wait = e.target.type === 'number' ? 600 : 0;
      debounce = setTimeout(function () { form.submit(); }, wait);
    });
  });

  var facetsPanel = document.getElementById('CollectionFacets');
  if (facetsPanel) {
    function setFacets(open) {
      facetsPanel.classList.toggle('is-open', open);
      document.body.classList.toggle('facets-locked', open);
      if (open) trapFocus(facetsPanel);
      else releaseFocus();
    }
    document.querySelectorAll('[data-facets-open]').forEach(function (b) {
      b.addEventListener('click', function () { setFacets(true); });
    });
    document.querySelectorAll('[data-facets-close]').forEach(function (b) {
      b.addEventListener('click', function () { setFacets(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setFacets(false);
    });
  }

  /* Variant pills: resolve selected options to a variant --------------------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var dataEl = picker.querySelector('[data-variant-data]');
    var idInput = picker.querySelector('[data-variant-id]');
    if (!dataEl || !idInput) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = picker.closest('form');
    var button = form ? form.querySelector('[data-add-button]') : null;
    var pricePill = document.querySelector('[data-price-pill]');

    function selected() {
      var opts = [];
      picker.querySelectorAll('.option-pills__input:checked').forEach(function (input) {
        opts[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
      });
      return opts;
    }

    function resolve() {
      var opts = selected();
      var match = variants.find(function (v) {
        return opts.every(function (val, i) { return v['option' + (i + 1)] === val; });
      });
      if (!match) {
        if (button) { button.disabled = true; button.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = match.id;
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available
          ? button.getAttribute('data-label-add')
          : button.getAttribute('data-label-sold-out');
      }
      if (pricePill) {
        var html = '';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          var pct = Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price);
          html = '<span class="price price--sale"><span class="price__regular">' + formatMoney(match.compare_at_price) +
            '</span><span class="price__sale">' + formatMoney(match.price) + '</span>' +
            '<span class="save-pill">SAVE ' + pct + '%</span></span>';
        } else {
          html = '<span class="price"><span>' + formatMoney(match.price) + '</span></span>';
        }
        pricePill.innerHTML = html;
      }
    }

    picker.addEventListener('change', resolve);
    resolve();
  });

  /* Search tabs: highlight the active result type ----------------------------- */
  var tabs = document.querySelector('[data-search-tabs]');
  if (tabs) {
    var currentType = new URLSearchParams(location.search).get('type') || '';
    tabs.querySelectorAll('a').forEach(function (a) {
      if ((a.getAttribute('data-type') || '') === currentType) a.classList.add('is-active');
    });
  }

  /* Sweet buzz — rotating review toasts ------------------------------------- */
  (function () {
    var buzz = document.querySelector('[data-buzz]');
    if (!buzz) return;
    try {
      if (sessionStorage.getItem('sugarrush:buzz-off')) { buzz.remove(); return; }
    } catch (e) {}
    var items = buzz.querySelectorAll('[data-buzz-item]');
    if (!items.length) { buzz.remove(); return; }
    var interval = parseInt(buzz.getAttribute('data-buzz-interval'), 10) || 22000;
    var i = Math.floor(Math.random() * items.length) - 1;
    var hideTimer, nextTimer;

    function showNext() {
      i = (i + 1) % items.length;
      var item = items[i];
      item.hidden = false;
      requestAnimationFrame(function () { item.classList.add('is-in'); });
      hideTimer = setTimeout(function () {
        item.classList.remove('is-in');
        setTimeout(function () { item.hidden = true; }, 450);
        nextTimer = setTimeout(showNext, interval);
      }, 6500);
    }

    buzz.addEventListener('click', function (e) {
      if (!e.target.closest('[data-buzz-close]')) return;
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
      try { sessionStorage.setItem('sugarrush:buzz-off', '1'); } catch (err) {}
      buzz.remove();
    });

    setTimeout(showNext, 8000);
  })();

  /* Smart product recommendations ------------------------------------------ */
  document.querySelectorAll('[data-recommendations-url]').forEach(function (el) {
    fetch(el.getAttribute('data-recommendations-url'))
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.querySelector('.product-card')) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });

  /* Recently viewed --------------------------------------------------------- */
  (function () {
    var KEY = 'sugarrush:recent';
    var section = document.querySelector('[data-recently-viewed]');
    var current = section ? section.getAttribute('data-current') : null;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }

    if (section) {
      var grid = section.querySelector('[data-recently-viewed-grid]');
      var toShow = list.filter(function (h) { return h && h !== current; }).slice(0, 4);
      if (grid && toShow.length) {
        Promise.all(toShow.map(function (handle) {
          return fetch('/products/' + handle + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        })).then(function (products) {
          var cards = products.filter(Boolean).map(function (pr) {
            var img = pr.featured_image
              ? '<img src="' + pr.featured_image + (pr.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="" loading="lazy" width="600" height="600">'
              : '';
            return '<li><div class="product-card"><div class="product-card__media">' + img +
              '</div><div class="product-card__info"><h3 class="product-card__title"><a href="/products/' + pr.handle + '">' + pr.title + '</a></h3>' +
              '<span class="price">' + formatMoney(pr.price) + '</span></div></div></li>';
          }).join('');
          if (cards) {
            grid.innerHTML = cards;
            section.hidden = false;
          }
        });
      }

      // record the current product
      if (current) {
        list = [current].concat(list.filter(function (h) { return h !== current; })).slice(0, 8);
        try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      }
    }
  })();

  /* Sticky mobile add-to-cart ---------------------------------------------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainForm = document.getElementById('ProductForm');
  if (stickyBar && mainForm && 'IntersectionObserver' in window) {
    var watchTarget = mainForm.querySelector('[data-add-button]') || mainForm;
    var stickyIO = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-shown', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    stickyIO.observe(watchTarget);
    var stickyBtn = stickyBar.querySelector('[data-sticky-add]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (typeof mainForm.requestSubmit === 'function') mainForm.requestSubmit();
        else mainForm.submit();
      });
    }
  }
})();
